import React, { useContext, createContext } from "react"

import { ServerResponseContext } from "~/lib/server"

export interface LoaderContext {
  rootLoaderData: ServerResponseContext["rootData"]
  siteLoaderData: ServerResponseContext["siteLoaderData"]
}

const LoaderContext = createContext<LoaderContext | null>(null)

export interface LoaderProviderProps {
  children: React.ReactNode
  rootLoaderData: LoaderContext["rootLoaderData"]
  siteLoaderData: LoaderContext["siteLoaderData"]
}

/**
 * Provides data for the useRouteLoaderData hook.
 * In Remix, this will be supported natively without the need for a provider.
 */
export function LoaderProvider({ children, rootLoaderData, siteLoaderData }: LoaderProviderProps) {
  const value: LoaderContext = { rootLoaderData, siteLoaderData }
  return <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>
}

/**
 * Return loader context.
 */
export function useLoaderContext() {
  const context = useContext(LoaderContext)
  if (!context) throw new Error(`No loader context. Ensure you have wrapped LoaderProvider.`)
  return context
}
